export * from 'preact/compat';
export { default } from 'preact/compat';
